import { useId } from 'react';

interface IconProps {
  className?: string;
}

export function InstagramIcon({ className }: IconProps) {
  const id = useId();
  const gradId = `ig-${id}`;
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true" role="img">
      <defs>
        <linearGradient id={gradId} x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#FFDD55" />
          <stop offset="25%" stopColor="#FF6B3B" />
          <stop offset="50%" stopColor="#E1306C" />
          <stop offset="75%" stopColor="#C13584" />
          <stop offset="100%" stopColor="#5851DB" />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradId})`}
        d="M 22.797 0 L 9.167 0 C 4.145 0 0 4.065 0 9.167 L 0 22.797 C 0 27.819 4.065 31.964 9.167 31.964 L 22.797 31.964 C 27.819 31.964 31.964 27.899 31.964 22.797 L 31.964 9.167 C 31.884 4.065 27.819 0 22.797 0 Z M 16.022 24.072 C 11.478 24.072 7.812 20.406 7.812 15.862 C 7.812 11.319 11.478 7.652 16.022 7.652 C 20.565 7.652 24.232 11.319 24.232 15.862 C 24.232 20.406 20.565 24.072 16.022 24.072 Z M 24.471 9.246 C 23.435 9.246 22.558 8.37 22.558 7.333 C 22.558 6.297 23.435 5.42 24.471 5.42 C 25.507 5.42 26.384 6.297 26.384 7.333 C 26.384 8.37 25.507 9.246 24.471 9.246 Z M 16.022 10.601 C 13.072 10.601 10.761 12.993 10.761 15.862 C 10.761 18.812 13.152 21.123 16.022 21.123 C 18.971 21.123 21.283 18.732 21.283 15.862 C 21.283 12.993 18.891 10.601 16.022 10.601 Z"
      />
    </svg>
  );
}

const TIKTOK_PATH =
  'M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.05z';

export function TikTokIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true" role="img">
      <path d={TIKTOK_PATH} fill="#25F4EE" transform="translate(-1.2 -1.2)" />
      <path d={TIKTOK_PATH} fill="#FE2C55" transform="translate(1.2 1.2)" />
      <path d={TIKTOK_PATH} fill="#FFFFFF" />
    </svg>
  );
}
